<div class="container-subscription-card" (click)="selectSubscription()" [ngClass]="{'selected': isSelected}">
  <div class="subscription-infos">
    <div class="name">{{subscription.name}}</div>
    <div class="description" [ngClass]="{'expanded': isExpanded}">{{subscription.description}}</div>
    <a (click)="toggleDescription(); $event.stopPropagation()" class="container-action-read">
      <ng-container *ngIf="!isExpanded">
        Voir plus
        <img ngSrc="/assets/images/icons/blue/arrow-more.svg" alt="Icon arrow more" height="16" width="16">
      </ng-container>
      <ng-container *ngIf="isExpanded">
        Voir moins
        <img ngSrc="/assets/images/icons/blue/arrow-less.svg" alt="Icon arrow less" height="16" width="16">
      </ng-container>
    </a>
  </div>
  <div class="price">
    {{subscription.basePrice | currency : 'EUR' : 'symbol' : '1.2-2' : 'fr-FR'}} <span>/mois</span>
  </div>
</div>
